import {ChangeDetectionStrategy, Component, Signal} from "@angular/core";
import {navParam} from "../../../navigation/navigation-params";
import {Page} from "../../../navigation/page";
import {Option} from "../option";
import {TranslateModule} from '@ngx-translate/core';
import {ModalPageLayoutComponent} from '../../../page-layout/modal-page-layout/modal-page-layout.component';
import {HtmlPipe} from '../../../utils/html.pipe';
import {ActivatableDirective} from '../../../ui-elements/activatable.directive';

@Component({
    selector: "woa-options-page",
    templateUrl: "options-page.component.html",
    styleUrl: "./options-page.component.scss",
    providers: [{provide: Page, useExisting: OptionsPageComponent}],
    imports: [
        HtmlPipe,
        ModalPageLayoutComponent,
        TranslateModule,
        ActivatableDirective
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OptionsPageComponent<T> extends Page {
    public readonly title: Signal<string> = navParam.required<string>("title");
    public readonly translationParams: Signal<Record<string, string | number>> = navParam<Record<string, string | number>>("translationParams");
    public readonly options: Signal<Option<T>[]> = navParam.required<Option<T>[]>("options");
    public readonly showNone: Signal<boolean> = navParam<boolean>("showNone", true);

    async activateOption(option: Option<T>): Promise<void> {
        void this.dismiss(option);
    }
}
